import { createActionCreator } from '@pressreader/appstore';

import { MODULE_NAME } from '../../constants';
import { Comment, Reply } from '../../types/comment';

const prefix = `${MODULE_NAME}/comments/`;

export const loadPreviousPageAction = createActionCreator(`${prefix}load-previous-page`);
export const loadPreviousPageBegan = createActionCreator(`${prefix}load-previous-page-began`);
export const loadPreviousPageDone = createActionCreator<{ comments: Comment[]; totalCommentsCount: number; rootCommentsCount: number }>(
    `${prefix}load-previous-page-done`,
);
export const loadPreviousPageFailed = createActionCreator(`${prefix}load-previous-page-failed`);

export const loadNextPageAction = createActionCreator(`${prefix}load-next-page`);
export const loadNextPageBegan = createActionCreator(`${prefix}load-next-page-began`);
export const loadNextPageDone = createActionCreator<{ comments: Comment[]; totalCommentsCount: number; rootCommentsCount: number }>(
    `${prefix}load-next-page-done`,
);
export const loadNextPageFailed = createActionCreator(`${prefix}load-next-page-failed`);

export const loadRepliesAction = createActionCreator<{ commentId: string }>(`${prefix}load-replies`);
export const loadRepliesBegan = createActionCreator<{ commentId: string }>(`${prefix}load-replies-began`);
export const loadRepliesDone = createActionCreator<{
    commentId: string;
    replies: Comment[];
    totalRepliesCount: number;
    /** Used when posting a reply which changes the order of available replies. */
    replace: boolean;
}>(`${prefix}load-replies-done`);
export const loadRepliesFailed = createActionCreator<{ commentId: string }>(`${prefix}load-replies-failed`);

export const commentEditStarted = createActionCreator<{ draftId: string; comment?: Comment }>(`${prefix}comment-edit-started`);
export const commentEditCancelled = createActionCreator<{ draftId: string }>(`${prefix}comment-edit-cancelled`);

export const postCommentAction = createActionCreator<{ draftId: string; commentId?: string; parentId?: string; text: string }>(
    `${prefix}post-comment`,
);
export const postCommentBegan = createActionCreator<{ draftId: string }>(`${prefix}post-comment-began`);
export const postCommentDone = createActionCreator(`${prefix}post-comment-done`);
export const postCommentFailed = createActionCreator(`${prefix}post-comment-failed`);

export const newReplyPosted = createActionCreator<{ reply: Reply; draftParentId: string }>(`${prefix}new-reply-posted`);
export const newCommentPosted = createActionCreator<{
    comment: Comment;
    comments: Comment[];
    offset: number;
    totalCommentsCount: number;
    rootCommentsCount: number;
}>(`${prefix}new-comment-posted`);

export const deleteCommentAction = createActionCreator<{ commentId: string }>(`${prefix}delete-comment`);
export const commentDeleted = createActionCreator<{ commentId: string }>(`${prefix}comment-deleted`);
export const commentUpdated = createActionCreator<{ comment: Comment }>(`${prefix}comment-updated`);

export const voteAction = createActionCreator<{ commentId: string; vote: 1 | -1 }>(`${prefix}vote`);
export const votesUpdated = createActionCreator<{ commentId: string; currentUserVote: 0 | 1 | -1; likesCount: number; dislikesCount: number }>(
    `${prefix}votes-updated`,
);

export const hideCommentAction = createActionCreator<{ commentId: string }>(`${prefix}hide-comment`);

export const banUserAction = createActionCreator<{ commentId: string }>(`${prefix}ban-user`);
export const userBanned = createActionCreator<{ userProfileName: string }>(`${prefix}user-banned`);

export const reportCommentAction = createActionCreator<{ commentId: string }>(`${prefix}report-comment`);
